(function () {
  // Inject small animation styles once
  try {
    var st = document.createElement('style');
    st.textContent = '@keyframes rmCartPulse{0%,100%{transform:none}45%{transform:scale(1.28)}}.rm-cart-pulse .icon-cart, .rm-cart-pulse svg{animation:rmCartPulse .45s ease;display:inline-block;}';
    document.head.appendChild(st);
  } catch (e) {}

  function refreshCartSilently() {
    try {
      if (window.EliteCart && typeof window.EliteCart.refreshCart === 'function') { window.EliteCart.refreshCart(); return; }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
  }

  function setBubble(count) {
    var bs = document.querySelectorAll('.cart-link__bubble');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      if (count > 0) { b.textContent = count > 99 ? '99+' : String(count); b.classList.add('cart-link__bubble--visible', 'rm-cart-badge'); }
      else { b.textContent = ''; b.classList.remove('cart-link__bubble--visible'); }
    }
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBubble(c.item_count); })
      .catch(function () {});
  }

  function flyToCart(card) {
    try {
      var img = card && (card.querySelector('.grid-product__image') || card.querySelector('.grid__item-image-wrapper img') || card.querySelector('img'));
      var cart = document.querySelector('.cart-link') || document.querySelector('a[href$="/cart"]');
      if (!img || !cart) return;
      var s = img.getBoundingClientRect();
      var t = cart.getBoundingClientRect();
      if (!s.width || !t.width) return;
      var fly = document.createElement('img');
      fly.src = img.currentSrc || img.src;
      fly.setAttribute('aria-hidden', 'true');
      fly.style.cssText = 'position:fixed;z-index:99999;left:' + s.left + 'px;top:' + s.top + 'px;width:' + s.width + 'px;height:' + s.height + 'px;border-radius:6px;object-fit:cover;pointer-events:none;opacity:.95;box-shadow:0 8px 24px rgba(0,0,0,.28);transition:transform .8s cubic-bezier(.5,-0.25,.3,1), opacity .8s ease;will-change:transform,opacity;';
      document.body.appendChild(fly);
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
      var dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.08) rotate(6deg)';
          fly.style.opacity = '0.25';
        });
      });
      setTimeout(function () {
        if (fly.parentNode) fly.parentNode.removeChild(fly);
        cart.classList.add('rm-cart-pulse');
        setTimeout(function () { cart.classList.remove('rm-cart-pulse'); }, 460);
      }, 820);
    } catch (e) {}
  }

  function openQuickViewOrProduct(productId, url) {
    var trigger = document.querySelector('.js-modal-open-quick-modal-' + productId);
    if (trigger && window.innerWidth >= 769) { trigger.click(); }
    else if (url) { window.location.href = url; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rm-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var url = btn.getAttribute('data-url');

    if (btn.getAttribute('data-soldout') === 'true') { if (url) window.location.href = url; return; }
    if (btn.getAttribute('data-multi') === 'true') { openQuickViewOrProduct(btn.getAttribute('data-product-id'), url); return; }

    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    flyToCart(btn.closest('.grid-product'));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        refreshCartSilently();
        refreshCount();
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        openQuickViewOrProduct(btn.getAttribute('data-product-id'), url);
      });
  }, true);

  // Keep the cart count badge in sync.
  // Event-driven (replaces the old 5s /cart.js polling loop) with a slow 60s safety net.
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCount, 200);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', refreshCount); } else { refreshCount(); }
  try { if (window.EliteCart && typeof window.EliteCart.onCartChange === 'function') { window.EliteCart.onCartChange(refreshCount); } } catch (e) {}

  // Theme/cart events (cart-drawer.liquid listens to cart:updated; theme dispatches it with detail.cart)
  document.addEventListener('cart:updated', function (evt) {
    if (evt && evt.detail && evt.detail.cart && typeof evt.detail.cart.item_count === 'number') {
      setBubble(evt.detail.cart.item_count);
    } else {
      scheduleRefresh();
    }
  });
  document.addEventListener('cart:change', scheduleRefresh);
  document.addEventListener('ajaxCart:updated', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);

  window.addEventListener('pageshow', refreshCount);
  window.addEventListener('focus', refreshCount);
  setInterval(refreshCount, 60000);
})();
